import { useEffect, type JSX } from 'react';
import type { ChatMultipleSelectContent } from '../../chatbot.types';
import { useChatMultipleSelectViewModel } from './chat-multiple-select.viewmodel';

type Props = {
  messageId: string;
  content: ChatMultipleSelectContent;
  onConfirm: (messageId: string, optionIds: string[]) => void;
};

export const ChatMultipleSelect = ({ messageId, content, onConfirm }: Props): JSX.Element => {
  const [state, viewModel] = useChatMultipleSelectViewModel(messageId, content, onConfirm);

  useEffect(() => {
    viewModel.setContent(content);
  }, [content, content.selectedIds, viewModel]);

  return (
    <div>
      {content.prompt && <div className='chatbot-select-prompt'>{content.prompt}</div>}
      <div className='chatbot-options'>
        {content.options.map((option) => (
          <label key={option.id} className={viewModel.getOptionClassName(option.id)}>
            <input
              type='checkbox'
              disabled={state.isAnswered}
              checked={viewModel.isSelected(option.id)}
              onChange={() => viewModel.handleToggle(option.id)}
            />
            {option.label}
          </label>
        ))}
      </div>
      {!state.isAnswered && (
        <div className='chatbot-multi-confirm'>
          <button
            className='chatbot-option-btn chatbot-option-btn--selected'
            disabled={viewModel.isConfirmDisabled()}
            onClick={viewModel.handleConfirm}
          >
            Bevestigen
          </button>
        </div>
      )}
    </div>
  );
};
